export default {
    backendUrl: process.env.VUE_APP_BACKEND_URL
}
